import React, { useEffect } from 'react';
import Select from 'react-select';
import {
	BOGLE_MEDIUM,
	SalesMetric,
	ReplenishmentMetric,
	InventoryMetric,
	measures,
	NEED_TO_BE_SELECTED,
	displayMetric,
	salesGMVSales,
	inventoryRetail,
	salesforInvunits,
	inventoryforUnits,
	inventoryforinStock,
	inventoryforAllUnits,
	SALES_METRIC,
	INVENTORY_METRIC,
} from '../../constants/constant';
import { getKeyByValue } from '../../helper/commonUtils';
import PropTypes from 'prop-types';
import { colors } from '../../theme/color-palette';

const { PURPLE, BOLD_BLACK, BOLD_WHITE, WHITE } = colors;

const groupedOptions = [
	{
		label: SALES_METRIC,
		options: SalesMetric,
	},
	{
		label: INVENTORY_METRIC,
		options: InventoryMetric,
	},
	{
		label: 'OPD Fulfilment Metric',
		options: ReplenishmentMetric,
	},
];

const groupHeadingStyle = () => ({
	fontFamily: BOGLE_MEDIUM,
	color: BOLD_BLACK,
	fontSize: 14,
	fontWeight: 500,
	textTransform: 'none',
});

const containerStyle = () => ({
	minHeight: '600px',
});

const indicatorsContainerStyle = () => ({
	color: PURPLE,
});

const colourStyles = {
	control: (styles, state) => ({
		...styles,
		backgroundColor: WHITE,
		padding: '7px',
		border: state.isFocused && `2px solid ${PURPLE}`,
		'&:hover': { borderColor: PURPLE },
		boxShadow: 0,
	}),
	option: (styles) => {
		return {
			...styles,
			backgroundColor: WHITE,
			color: BOLD_BLACK,
			cursor: 'pointer',
			':hover': {
				...styles[':hover'],
				backgroundColor: BOLD_WHITE,
			},
			zIndex: 10,
		};
	},

	groupHeading: (styles) => ({ ...styles, ...groupHeadingStyle() }),
	menuList: (styles) => ({ ...styles, ...containerStyle() }),
	menu: (styles) => ({ ...styles, zIndex: 9999 }),
	dropdownIndicator: (styles) => ({
		...styles,
		...indicatorsContainerStyle(),
	}),
};

const findOption = (list, metric) => {
	return list.find((item) => item.value === metric);
};

const getDefaultOptions = (metric) => {
	if (['netsales', 'units', 'gmv'].includes(metric)) {
		return findOption(SalesMetric, metric);
	} else if (
		['firstTimePickRate', 'nilPickRate', 'preSubRate', 'postSubRate'].includes(
			metric
		)
	) {
		return findOption(ReplenishmentMetric, metric);
	} else {
		return findOption(InventoryMetric, metric);
	}
};

const GroupedMetric = ({ getValue, defaultValue, selectedA, isEditFlow }) => {
	const metricKey = getKeyByValue(measures, defaultValue);
	const defaultOption = getDefaultOptions(metricKey ? metricKey : selectedA);

	useEffect(() => {
		getValue(defaultOption ? defaultOption?.value : NEED_TO_BE_SELECTED);
	}, [defaultValue]);

	const handleChange = (choice) => {
		getValue(choice?.value);
	};

	const displayOptions = () => {
		let groupedOptions = [];
		const metricName = selectedA;
		if (
			[
				'netsales',
				'gmv',
				'onHand$',
				'onOrder$',
				'dctostore$',
				'storeInWarehouse$',
			].includes(metricName)
		) {
			groupedOptions = [
				{
					label: SALES_METRIC,
					options: salesGMVSales,
				},
				{
					label: INVENTORY_METRIC,
					options: inventoryRetail,
				},
			];
			return groupedOptions;
		} else if (
			[
				'onHandUnits',
				'onOrderUnits',
				'dctostoreUnits',
				'storeInWarehouseUnits',
			].includes(metricName)
		) {
			groupedOptions = [
				{
					label: SALES_METRIC,
					options: salesforInvunits,
				},
				{
					label: INVENTORY_METRIC,
					options: inventoryforUnits,
				},
			];
			return groupedOptions;
		} else if (metricName === 'storeInStock') {
			groupedOptions = [
				{
					label: INVENTORY_METRIC,
					options: inventoryforinStock,
				},
			];
			return groupedOptions;
		} else if (
			[
				'firstTimePickRate',
				'nilPickRate',
				'preSubRate',
				'postSubRate',
			].includes(metricName)
		) {
			groupedOptions = [
				{
					label: 'OPD Fulfilment Metric',
					options: ReplenishmentMetric,
				},
			];
			return groupedOptions;
		} else if (metricName === 'units') {
			groupedOptions = [
				{
					label: SALES_METRIC,
					options: salesforInvunits,
				},
				{
					label: INVENTORY_METRIC,
					options: inventoryforAllUnits,
				},
			];
			return groupedOptions;
		}
		return groupedOptions;
	};

	return (
		<Select
			options={displayMetric[selectedA] ? displayOptions() : groupedOptions}
			styles={colourStyles}
			defaultValue={defaultOption}
			isDisabled={defaultValue && isEditFlow ? true : false}
			onChange={(choice) => handleChange(choice)}
		/>
	);
};

GroupedMetric.propTypes = {
	getValue: PropTypes.func,
	defaultValue: PropTypes.string,
	selectedA: PropTypes.string,
	isEditFlow: PropTypes.bool,
};

export default GroupedMetric;
